import { render, staticRenderFns } from "./PointsForStudent.vue?vue&type=template&id=7e551666&"
import script from "./PointsForStudent.vue?vue&type=script&lang=js&"
export * from "./PointsForStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports